let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Eo5EW")).then(() => parcelRequire('iIjRQ'));